import { SortableElement } from "react-sortable-hoc";
import { useSpaceNotificationsState } from "@circle-react/contexts/sidebarNotificationsContext";
import { useSpaceLinkWithDefaultTab } from "@circle-react/helpers/spaceHelpers";
import type { SpaceViewProps } from "./SpaceView";
import { SpaceView } from "./SpaceView";

export interface SpaceProps {
  space: SpaceViewProps["space"];
}

const Space = SortableElement<SpaceProps>(({ space }: SpaceProps) => {
  const getSpaceLinkWithDefaultTab = useSpaceLinkWithDefaultTab();
  const buttonLink = getSpaceLinkWithDefaultTab(space);

  const { spaces: spaceNotifications } = useSpaceNotificationsState();
  const spaceNotificationDetail = spaceNotifications.find(
    (spaceItem: any) => spaceItem.id === space.id,
  );

  return (
    <SpaceView
      space={space}
      buttonLink={buttonLink}
      spaceNotificationDetail={spaceNotificationDetail}
    />
  );
});

export default Space;
